export default __webpack_public_path__ + "static/media/Group.9539c0d4.svg";